module.exports = __webpack_public_path__ + "static/media/app11.15ee1df5.png";